import { clearRow } from "./Table/utils";
import {
  changeMonthsSpecificColumnVisibilityState,
  changeSpecificFieldVisibilityState,
  generateInitialColumnsVisibilityState,
  generateQuarterColumnsVisibilityState,
  INITIAL_COLUMNS_STATE,
} from "./Toolbar/utils";

export const forecastStoreSlice = (set) => ({
  forecastSelectedOwner: 0,
  forecastSelectedCategory: null,
  forecastSelectedMarketplace: 1,
  forecastSelectedYear: new Date().getFullYear(),
  forecastSelectedQuarter: "all",
  forecastSearch: "",
  forecastColumnsVisibility: generateInitialColumnsVisibilityState(),
  forecastGlobalColumnsVisibility: INITIAL_COLUMNS_STATE,
  forecastEditedRows: {},
  forecastEditedMonthExchangeRates: {},
  forecastEditedExchangeRateYear: new Date().getFullYear(),
  forecastSelectedBrand: null,
  tableCustomizationTooltip: false,
  forecastSelectedKam: [],

  setForecastSelectedKam: (selectedKam) =>
    set(() => ({ forecastSelectedKam: selectedKam })),
  clearForecastSelectedKam: () => set(() => ({ forecastSelectedKam: [] })),

  setForecastSelectedOwner: (selectedOwner) =>
    set(() => ({ forecastSelectedOwner: selectedOwner })),
  clearForecastSelectedOwner: () => set(() => ({ forecastSelectedOwner: 0 })),
  setForecastSelectedCategory: (selectedCategory) =>
    set(() => ({ forecastSelectedCategory: selectedCategory })),
  clearForecastSelectedCategory: () =>
    set(() => ({ forecastSelectedCategory: null })),
  setForecastSelectedMarketplace: (selectedMarketplace) =>
    set(() => ({ forecastSelectedMarketplace: selectedMarketplace })),
  resetForecastSelectedMarketplace: () =>
    set(() => ({ forecastSelectedMarketplace: 1 })),
  setForecastSelectedYear: (selectedYear) =>
    set(() => ({ forecastSelectedYear: selectedYear })),
  setForecastSelectedQuarter: (selectedQuarter) =>
    set(() => ({ forecastSelectedQuarter: selectedQuarter })),
  setForecastSearch: (search) => set(() => ({ forecastSearch: search })),
  changeForecastSpecificFieldColumnVisibility: ({ name, value }) =>
    set((state) => ({
      forecastColumnsVisibility: changeSpecificFieldVisibilityState(
        state.forecastColumnsVisibility,
        name,
        value,
      ),
    })),
  changeForecastMonthsSpecificFieldColumnVisibility: ({
    quarter,
    name,
    value,
  }) =>
    set((state) => ({
      forecastColumnsVisibility: changeMonthsSpecificColumnVisibilityState(
        state.forecastColumnsVisibility,
        quarter,
        name,
        value,
      ),
    })),
  changeForecastQuarterVisibility: (quarter) =>
    set((state) => ({
      forecastColumnsVisibility: generateQuarterColumnsVisibilityState(
        quarter,
        state.forecastGlobalColumnsVisibility,
      ),
    })),
  resetForecastColumnsVisibility: () =>
    set(() => ({
      forecastColumnsVisibility: generateInitialColumnsVisibilityState(),
    })),
  changeForecastGlobalColumnsVisibility: ({ name, value }) =>
    set((state) => ({
      forecastGlobalColumnsVisibility: {
        ...state.forecastGlobalColumnsVisibility,
        [name]: value,
      },
    })),
  resetForecastGlobalColumnsVisibility: () =>
    set(() => ({ forecastGlobalColumnsVisibility: INITIAL_COLUMNS_STATE })),
  addForecastEditedRow: (editedRow) =>
    set((state) => {
      const clearedRow = clearRow(editedRow?.row);

      const gmv_local =
        (editedRow?.row?.[editedRow.month]?.tsu ?? 0) *
        (editedRow?.row?.[editedRow.month]?.pvp ?? 0);
      const gmv_usd =
        editedRow?.tc && editedRow?.tc !== 0
          ? gmv_local / editedRow?.tc
          : clearedRow.gmv_usd;

      return {
        forecastEditedRows: {
          ...state.forecastEditedRows,
          [editedRow.id]: {
            ...clearedRow,
            [editedRow.month]: {
              ...editedRow?.row?.[editedRow.month],
              gmv_local,
              gmv_usd,
            },
          },
        },
      };
    }),
  clearForecastEditedRows: () =>
    set(() => ({
      forecastEditedRows: {},
    })),

  addForecastEditedMonthExchangeRate: (exchangeRate) =>
    set((state) => ({
      forecastEditedMonthExchangeRates: {
        ...state.forecastEditedMonthExchangeRates,
        [exchangeRate.month]: exchangeRate.rate,
      },
    })),
  clearForecastEditedMonthExchangeRates: () =>
    set(() => ({ forecastEditedMonthExchangeRates: {} })),

  setForecastEditedExchangeRateYear: (year) =>
    set(() => ({ forecastEditedExchangeRateYear: year })),
  resetForecastEditedExchangeRateYear: () =>
    set(() => ({ forecastEditedExchangeRateYear: new Date().getFullYear() })),
  setForecastSelectedBrand: (brand) =>
    set((state) => {
      const newBrand = state.forecastSelectedBrand === brand ? null : brand;
      return { forecastSelectedBrand: newBrand };
    }),
  resetForecastSelectedBrand: () =>
    set(() => ({ forecastSelectedBrand: null })),
  toggleTableCustomizationTooltip: () =>
    set((state) => ({
      tableCustomizationTooltip: !state.tableCustomizationTooltip,
    })),

  openTableCustomizationTooltip: () =>
    set(() => ({ tableCustomizationTooltip: true })),
  closeTableCustomizationTooltip: () =>
    set(() => ({ tableCustomizationTooltip: false })),
  forecastClearFilters: () =>
    set(() => ({
      forecastSelectedCategory: null,
      forecastSelectedBrand: null,
      forecastSelectedOwner: 0,
      forecastSelectedYear: new Date().getFullYear(),
      forecastGlobalColumnsVisibility: INITIAL_COLUMNS_STATE,
      forecastSearch: "",
    })),
});
